require('./GeneralViewCalendar.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @components
const BrokerMarketsCalendarEvents = require('components/broker/brokerMarketsCalendarEvents/brokerMarketsCalendarEvents');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKLink } = require('commonsComponents/OKLink');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @constants
const { BROKER_GENERAL_CALENDAR_MAX_EVENTS } = require('constants/index');

class GeneralViewCalendar extends React.Component {
    buildEventsBlock(events, MAX_EVENTS) {
        if (events.size > 0) {
            return (
                <BrokerMarketsCalendarEvents
                    events={events}
                    max={MAX_EVENTS}
                    pageName={this.props.pageName}
                />
            );
        } else {
            return (
                <div className="broker-general-calendar__empty-state">
                    <EmptyState
                        primaryText={formatText('broker-generalCalendarEmptyStateText')}
                        iconType="agenda-wealth"
                        pageName={this.props.pageName}
                    />
                </div>
            );
        }
    }

    render() {
        const {
            marketAgendaText,
            todayText,
            quantity,
            eventsText,
            calendarEvents
        } = this.props;

        const MAX_EVENTS_GENERAL = BROKER_GENERAL_CALENDAR_MAX_EVENTS;
        const eventsBlock = this.buildEventsBlock(calendarEvents, MAX_EVENTS_GENERAL);
        const seeAllEventsLink = (
            <div className="broker-general-calendar__show-all">
                <OKLink 
                    modifier="widget" 
                    to="/myprofile/broker/marketsAgenda"
                    onClick={() => taggingEventHandled(this.props.pageName, 'seeMoreEvents')}
                >
                    <FormattedText value="broker-seeMoreEvents" />
                </OKLink>
            </div>
        );

        const totalCount = (
            <div>
                <div className="broker-general-calendar__count">
                    {quantity} {eventsText}
                </div>
                <div>
                </div>
            </div>
        );

        return (
            <ContentBox
                id="broker-general-calendar"
                title={marketAgendaText}
                smallTitle={true}
                customClassName="broker-general-calendar"
                rightContent={totalCount}
                footerContent={seeAllEventsLink}
                modifier="complementary"
                product="wealth"
            >
                <div className="col-xs-5">
                    <div className="row">
                        <div className="broker-general-calendar__period">
                            <FormattedText
                                value="broker-generalCalendarPeriodText"
                                injectedStrings={todayText}
                                className="broker-general-calendar__period-date"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-xs-7">
                    <div className="row">
                        <div className="broker-general-calendar__period-icon">
                            <OKIconIllustrative icon="agenda" product="wealth" />
                        </div>
                    </div>
                </div>
                {eventsBlock}
            </ContentBox>
        );
    }
}

GeneralViewCalendar.propTypes = {
    marketAgendaText: PropTypes.string,
    eventsText: PropTypes.string,
    todayText: PropTypes.array,
    calendarEvents: PropTypes.array,
    quantity: PropTypes.number,
    pageName: PropTypes.string
}

module.exports = GeneralViewCalendar;
